import { LEVEL_THRESHOLDS } from '@iqrapath/shared'

/** Garden levels 1..5 (docs/PRD.md §8.4); art in public/img/garden/lv<n>.webp. */
export const GARDEN = ['Setapak baru dirintis', 'Setapak mulai dirawat', 'Taman mulai hidup', 'Taman yang hangat', 'Taman rimbun'] as const

/** Hero of the Perjalanan hub (docs/UX-PLAYBOOK.md §7.7): the garden level and the light still needed for the next one. */
export function Garden({ light, level }: { light: number; level: number }) {
  const from = LEVEL_THRESHOLDS[level - 1] ?? 0
  const next = LEVEL_THRESHOLDS[level] as number | undefined
  const pct = next === undefined ? 100 : Math.round(((light - from) / (next - from)) * 100)
  const name = GARDEN[level - 1]
  const src = `/img/garden/lv${level}`
  return (
    <section className="card garden" aria-labelledby="garden-h">
      <div className="garden-sky">
        <img src={`${src}.webp`} srcSet={`${src}.webp 640w, ${src}@2x.webp 1280w`} sizes="(min-width: 760px) 640px, 92vw" width={640} height={640} alt={`Tamanmu di tingkat ${level}: ${name}`} />
      </div>
      <div className="garden-body">
        <p className="eyebrow">Tamanmu · tingkat {level} dari {GARDEN.length}</p>
        <h2 id="garden-h">{name}</h2>
        <div className="bar" role="progressbar" aria-label="Cahaya menuju tingkat berikutnya" aria-valuemin={from} aria-valuemax={next ?? light} aria-valuenow={light}>
          <i style={{ width: `${pct}%` }} />
        </div>
        <p className="garden-num">
          <b className="num">{light}</b> cahaya
          {next === undefined ? ' · tamanmu sudah rimbun' : ` · ${next - light} lagi menuju “${GARDEN[level]}”`}
        </p>
        <p className="muted garden-fine">Cahaya ini hanya penanda langkahmu, bukan hitungan pahala. Soal pahala, itu urusan Allah.</p>
        <p className="muted garden-fine">Cahaya datang dari ayat harian, kebiasaan, niat yang selesai, muhasabah, dan tantangan 7 hari.</p>
      </div>
    </section>
  )
}
